<template>
    <form style="width:520px">
        <div class="pageTitle">
            <span class="md-title">{{ $t('user.profile.info.title')}}</span>
        </div>
        <md-field>
            <label>{{ $t("common.email") }}</label>
            <md-input v-model="form.email"
                      type="email"
                      required
                      disabled
            ></md-input>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('firstName') }]">
            <label>{{ $t("common.firstName") }}</label>
            <md-input v-model="form.firstName"
                      required
                      data-vv-name="firstName"
                      v-validate="modelValidations.firstName"
            ></md-input>
            <span v-if="errors.has('firstName')" class="validation-error">{{ errors.first("firstName") }}</span>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('surName') }]">
            <label>{{ $t("common.lastName") }}</label>
            <md-input v-model="form.surName"
                      required
                      data-vv-name="surName"
                      v-validate="modelValidations.surName"
            ></md-input>
            <span v-if="errors.has('surName')" class="validation-error">{{ errors.first("surName") }}</span>
        </md-field>
        <md-field>
            <label>{{ $t("common.positionInCompany") }}</label>
            <md-input v-model="form.position"></md-input>
        </md-field>
        <md-field>
            <label>{{ $t("common.phone") }}</label>
            <md-input v-model="form.phone"></md-input>
        </md-field>

        <div class="flex flex_center">
            <md-button class="opacity_5" :class="{'md-primary': hasChanges && isFormValid}" @click="submit('info')">
                {{ $t("common.button.submit") }}
            </md-button>
        </div>
    </form>
</template>
<script>
import {userProfileApi} from "@/common/api/userProfileApi";
import {validateForm, validateRequiredFields} from "@/validation/validation";

export default {
    data() {
        return {
            modelValidations: {
                firstName: {
                    required: true
                },
                surName: {
                    required: true
                },
            },
            form: {
                id: "",
                firstName: "",
                surName: "",
                position: "",
                phone: "",
                email: "",
            },
            originData: {
				firstName: "",
				surName: "",
				position: "",
				phone: "",
				email: "",
            }
        };
    },
    mounted() {
        this.loadProfile();
    },
    methods: {
        submit() {
            if (!this.hasChanges) {
                return;
            }

            validateForm(this, this.$validator).then(() => {
                userProfileApi.operation.editProfile(this.form)
                    .then(() => {
                        this.toastSuccess();
                        this.loadProfile();
                    })
                    .catch(err => {
                        this.toast(err)
                    })
            }).catch(e => this.toast(e));
        },
        loadProfile() {
            userProfileApi.inspection.getProfile()
                .then(res => {
                	this.form = {
                		id: res.id,
						firstName: res.firstName,
					    surName : res.surName,
					    position : res.position,
					    phone : res.phone,
					    email : res.email
                    };
					this.originData = {...this.form};

					this.$emit("loaded", this.form);
                })
                .catch(err => {
                    this.toast(err);
                });
        }
    },
    computed: {
        hasChanges() {
            let changed = false;
            for (let field in this.form) {
                if (this.form[field] !== this.originData[field]) {
                	changed = true;
                }
            }
            return changed;
        },
        isFormValid() {
          return validateRequiredFields(this.form, this.modelValidations);
        }
    }
};
</script>